define('models/accounts/accounttransaction',['backbone'
], function (Backbone) {
    var AccountTransaction = Backbone.Model.extend({
        initialize: function (options) {
            options = options || {};
            this.Description = options.DES;
            this.AccountID = options.AID;
            this.TransactionDT = options.TDT;
            this.CreditAmount = options.CA;
            this.DebitAmount = options.DA;
            this.Memo = options.MEM;
            this.Allocations = options.ATA;
        },
		parse: function (data) {
			var response = {};
			response.Description = data.DES;
			response.AccountID = data.AID;
			response.TransactionDT = data.TDT;
			response.CreditAmount = data.CA;
			response.DebitAmount = data.DA;
			response.Memo = data.MEM;
			response.Allocations = data.ATA;
			return response;
		},
		save: function (attributes, options) {
			options       = options || {};
			attributes    = attributes || {};;

			var data = {};
			data.DES = this.attributes.Description;
			data.AID = this.attributes.AccountID;
			data.TDT = this.attributes.TransactionDT;
			data.CA = this.attributes.CreditAmount;
			data.DA = this.attributes.DebitAmount;
			data.MEM = this.attributes.Memo;
			data.ATA = this.attributes.Allocations

			this.attributes = data;

			return Backbone.Model.prototype.save.call(this, attributes, options);
		}
	});
	return AccountTransaction;
});

